import { AfterViewInit, Component, inject } from "@angular/core";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { LangChangeEvent, TranslatePipe, TranslateService } from "@ngx-translate/core";
import { WcmService } from "@shared/services/wcm/wcm.service";
import { SharedModule } from "@shared/shared.module";

@Component({
	template: '<section class="pt-4 px-2 px-lg-0"><h2>{{ "menu.privacy" | translate }}</h2><div class="free-text-page pt-3" [innerHTML]="privacy"></div></section>',
	imports: [
		SharedModule,
		TranslatePipe
	],
	styleUrl: "./private-privacy.component.scss"
})

export class PrivatePrivacyComponent implements AfterViewInit {
	protected privacy = "";
	// market: any;
	wcmService = inject(WcmService);

	translate = inject(TranslateService);
	constructor() {
		this.translate.onLangChange
			.pipe(takeUntilDestroyed())
			.subscribe(
				(event: LangChangeEvent) => {
					this.setData(event.lang);
				}
			);
	}
	private setData(lang: string) {
		this.wcmService.getDocument("privacy", lang)
			.subscribe({
				next: value => {
					this.privacy = value;
				},
				error: () => { this.privacy = ""; }
			});
	}
	ngAfterViewInit() {
		this.setData(this.translate.getCurrentLang());
	}
}